// Core
import { 
	Box, 
	useColorModeValue
} from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { LockedIcon } from 'components/Icons/Icons';

const LockedContent = () => {
	const blurColor = useColorModeValue('rgba(255, 255, 255, 0.30)','rgba(0, 0, 0, 0.30)');

	return (
		<Box
			position="absolute"
		    bg={blurColor}
		    backdropFilter="blur(6px)"
		    zIndex="9"
		    top="0"
		    left="0"
		    borderRadius="16px"
		    width="100%"
		    height="100%">
		    <Box
		    	left="50%"
			    position="relative"
			    top="50%"
			    transform="translate(-50%, -50%)"
		    	w="110px"
				h="110px" 
				borderRadius="full"
				bg="linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)" 
		    	boxShadow="0px 0 40px rgba(21, 168, 253, 1)">
				<Box overflow="hidden" p="23px">
					<LockedIcon fontSize="64px" />
					<Lines className="abstract-lines" style={{ zIndex: '1', top: '0%', transform: 'rotate(259deg) scale(0.2)', right: '0%', left: 'unset' }} />
				</Box>
			</Box>
		</Box> 
	);
};

export default LockedContent;